import { ItemCategoryTypes } from '../../domain/item.category.type';

export class AssetStatisticsItem {
    ItemCategoryType: ItemCategoryTypes;
    Name: String;
    Label: String;
    Count: Number;
}

export class AssetStatisticsItemArray extends Array<AssetStatisticsItem> {
    
    constructor(...items: AssetStatisticsItem[]) {
        super(...items);
        Object.setPrototypeOf(this, AssetStatisticsItemArray.prototype);
    }
}
